jQuery.feature_import("js-select-toggler",
  () => require("./select-toggler.js"),
  mod => mod.feature_js_select_toggler
);